export default {
  title: 'Components/Accordion',
  tags: ['autodocs'],
  argTypes: {
    design: {
      control: { type: 'select' },
      options: ['bg-border', 'no-border'],
      description: 'Choice of design between two options: bg-border and no-border.',
    },
    accordion_icon_class: {
      control: { type: 'text' },
      description: 'Custom class to be applied to the accordion icon',
    },
    accordion_icon_text: {
      control: 'text',
      description: 'Material icon to display in the header',
    },
    accordion_header_end_icon: {
      control: 'text',
      description: 'Material icon to display in the header',
    },
    accordion_id: {
      control: 'text',
      description: 'Material icon to display in the header',
    },
    
    header_text: {
      control: 'text',
      description: 'Header text of the accordion',
    },
    sub_title: {
      control: 'text',
      description: 'Body description of the accordion',
    },
    body_description: {
      control: 'text',
      description: 'Body description of the accordion',
    },
    link_button_text: {
      control: { type: 'text' },
      description: 'Custom class to be applied to the accordion icon',
    },
    custom_class: {
      control: { type: 'text' },
      description: 'Custom class to be applied to the accordion',
    },
    component_mode: {
      control: { type: 'check' },
      options: ['light-mode'],
      description: 'Mode of the accordion component',
    },
    default_open: {
      control: { type: 'boolean' },
      description: 'If true, accordion will be open by default',
    },
    
    
  },
  parameters: {
    docs: {
      description: {
        component: `
To use the \`dda-accordion\` component, pass the following props:

\`\`\`html
<dda-accordion 
  design="bg-border" 
  accordion_icon_class="material-icons  material-symbols-outlined"
  accordion_icon_text="home">
  header_text="Accordion Header" 
  sub_title="Sub Title"
  body_description="This is the accordion body content." 
  custom_class="" 
  component_mode=""
  
</dda-accordion>
\`\`\`
`,
      },
    },
  },
};

const Template = (args) => {
  const attributes = Object.entries(args)
    .filter(([key, value]) => value !== undefined && key !== 'text')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  return `<dda-accordion ${attributes}></dda-accordion>`;
};

export const BgBorder = Template.bind({});
BgBorder.args = {
  design: 'bg-border',
  accordion_icon_class: 'material-icons  material-symbols-outlined',
  accordion_icon_text: 'home',
  accordion_header_end_icon: 'info',
  accordion_id: 'accordionOne',
  header_text: 'Accordion Header',
  sub_title: 'Sub Title',
  body_description: 'This is the accordion body content.',
  link_button_text: "Button",
  custom_class: '',
  component_mode: '',
  default_open:'false',
};

export const NoBorder = Template.bind({});
NoBorder.args = {
  design: 'no-border',
  accordion_icon_class: 'material-icons  material-symbols-outlined',
  accordion_icon_text: 'home',
  accordion_header_end_icon: 'info',
  accordion_id: 'accordionOne',
  header_text: 'Accordion Header',
  sub_title: 'Sub Title',
  body_description: 'This is the accordion body content.',
  link_button_text: "Button",
  custom_class: '',
  component_mode: '',
  default_open:'false',
};
